import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { svgIcons } from 'src/assets/images/MDM/mdlz-icons';

interface SvgIcon {
  path: string;
  fill: string;
  viewBox: string;
  viewbox_width: number;
  viewbox_height: number;
  size?: number;
  outlineColor?: string;
  extra?: string;
}

@Component({
  selector: 'mdlz-icon',
  templateUrl: './mdlz-icon.component.html',
})
export class MdlzIconComponent implements OnInit {
  @Input() iconName: string;
  @Input() fillColor: string = '#fff';
  @Input() outlineColor: string = '#fff';
  @Input() size: number | string = 24;

  // public size = 24;

  public svgData: SvgIcon;

  @ViewChild('customIcon') customIcon: ElementRef;

  ngOnInit(): void {
    if (this.iconName) {
      this.svgData = svgIcons[this.iconName];
      // this.size = this.svgData.size;
      // this.svgData.viewBox = `0 0 ${this.svgData.size} ${this.svgData.size}`;
      this.svgData.viewBox = `0 0 ${this.svgData.viewbox_width} ${this.svgData.viewbox_height}`;
    }
  }

  ngAfterViewInit() {
    let tempData: string = `
      <path d="${this.svgData.path}" fill="${this.fillColor}"/>
      ${this.svgData?.extra}
    `;
    if (this.svgData?.extra) {
      tempData = tempData.replaceAll('#OUTLINE', this.outlineColor);
      tempData = tempData.replaceAll('#FILL', this.fillColor);
    }

    this.customIcon.nativeElement.innerHTML = tempData;
  }
}
